import { createAction, handleAction } from 'redux-actions'
import config from '../../config'

const { bounds } = config

export const initialState = {
  viewport: {
    latitude: 51.043365925630624,
    longitude: 13.74188917298561,
    zoom: 13.5,
    width: null,
    height: null,
  },
  transition: false,
  bounds,
  histMapBounds: {
    1866: [
      [13.780770822411238, 51.014142248603044],
      [13.811326844927716, 51.072525525166945],
      [13.712191434796912, 51.0933010619526],
      [13.681784359336849, 51.03458905860695],
      [13.780770822411238, 51.014142248603044],
    ],
    1911: [
      [13.86771815614199, 51.084290481431246],
      [13.796821317381706, 51.084722166040244],
      [13.797336306525278, 51.106894543154986],
      [13.654340987674185, 51.10716421464564],
      [13.653997661573381, 51.08488404672998],
      [13.618549242196929, 51.0846682056845],
      [13.618291747621466, 51.06216125103647],
      [13.653911830049491, 51.06216125103647],
      [13.653740167004713, 51.03985939992117],
      [13.618635073717257, 51.03991341253119],
      [13.618034253050075, 51.0172766144593],
      [13.689274417909536, 51.0172225754637],
      [13.689531912478026, 50.99495315087111],
      [13.72489450033438, 50.99495315087111],
      [13.725409489478002, 51.017168536405],
      [13.760600414286346, 51.01700641885101],
      [13.761029571906027, 50.99479095565849],
      [13.796134665189845, 50.99473689046163],
      [13.796220496713811, 50.97224030488689],
      [13.831754747618277, 50.97229439628927],
      [13.831926410666261, 50.99473689046171],
      [13.867546493094338, 50.99452062904445],
      [13.867546493094974, 51.01700641885114],
      [13.832183905238569, 51.017222575463855],
      [13.83244139981075, 51.03953532293876],
      [13.867632324619093, 51.03942729677402],
      [13.86788981919056, 51.08434444222827],
      [13.86771815614199, 51.084290481431246],
    ],
    1946: [
      [13.867803987668196, 51.08418255964926],
      [13.796821317383792, 51.08477612633281],
      [13.797078811955668, 51.10689454315458],
      [13.689961070100455, 51.10716421464534],
      [13.689360249432992, 51.08493800683337],
      [13.65434098767243, 51.08472216603966],
      [13.653740167005248, 51.0624851697315],
      [13.618377579149122, 51.06216125103579],
      [13.61872090524466, 51.04002143756182],
      [13.654083493101039, 51.03969736171238],
      [13.653997661576994, 50.99479095565777],
      [13.781972463746596, 50.99479095565767],
      [13.781972463746596, 50.97229439628841],
      [13.832098073717528, 50.972294396288355],
      [13.832012242193638, 50.99441249795698],
      [13.867288998525668, 50.99462875987857],
      [13.867803987668196, 51.08418255964926],
    ],
    1949: [
      [13.797139589281636, 51.15189329808307],
      [13.725787883439589, 51.15203004068167],
      [13.725700683119921, 51.12950306939939],
      [13.689992130098384, 51.12966724009082],
      [13.689883129621021, 51.10729360574128],
      [13.654137689263921, 51.107174255253376],
      [13.653891175459147, 51.08710014329718],
      [13.652168968036156, 51.08759310568892],
      [13.650185159554317, 51.084826970939226],
      [13.618357023117426, 51.08477219433697],
      [13.618248022548796, 51.039819825592815],
      [13.64698054563139, 51.03976499572431],
      [13.648768153272385, 51.03762657920622],
      [13.650272359719384, 51.03779107628848],
      [13.652212568055981, 51.037681411618784],
      [13.652190767983322, 51.03677666829803],
      [13.654021975831922, 51.03539210263709],
      [13.653912975292885, 50.994933566004356],
      [13.760602632482023, 50.99463170873964],
      [13.760428231713735, 50.97216527302662],
      [13.902957242318637, 50.971918177911945],
      [13.90341504432326, 51.01675813135524],
      [13.890369299332392, 51.016820253991796],
      [13.889753376908672, 51.01827048352203],
      [13.88953340467206, 51.01804354218041],
      [13.887826419821698, 51.01804354218041],
      [13.887069715279308, 51.01817085088397],
      [13.88693773191721, 51.01804907735834],
      [13.88567069164083, 51.017982655306234],
      [13.885221948209617, 51.01809889383499],
      [13.884949182527405, 51.017954979433654],
      [13.883497365544063, 51.01788855724677],
      [13.883154208802555, 51.017318429551885],
      [13.882687867656859, 51.01690328362352],
      [13.881491218439777, 51.01679811272104],
      [13.880884094974046, 51.01703059542614],
      [13.88047054717314, 51.01690881893756],
      [13.877962863292852, 51.0168147186672],
      [13.876546241839106, 51.017977120120364],
      [13.875859928301589, 51.017722501328755],
      [13.875402386013121, 51.016930960121016],
      [13.871178918425217, 51.01691435421648],
      [13.871152521752773, 51.01723540066077],
      [13.870133282086137, 51.01763239747655],
      [13.86992406978298, 51.01746366446881],
      [13.869527102828265, 51.017446791118815],
      [13.869167686840749, 51.017649270759016],
      [13.86938762793907, 51.01794286466678],
      [13.868958474537592, 51.018087973600025],
      [13.868631244996838, 51.018121719827214],
      [13.868336202025692, 51.01807447512543],
      [13.868003608087342, 51.018351193320015],
      [13.868003608087342, 51.01856379277221],
      [13.867778302530132, 51.01871902352827],
      [13.867897732790189, 51.05207442232411],
      [13.868090851839266, 51.052229540824385],
      [13.868664844527482, 51.05199011854071],
      [13.869646533026973, 51.05299500936983],
      [13.86899207406826, 51.05326477497473],
      [13.870526892545291, 51.055442042499564],
      [13.870506600668584, 51.05679584560069],
      [13.870488287895768, 51.05729846751651],
      [13.870701936865816, 51.05781643096549],
      [13.870622581540067, 51.0580888390616],
      [13.869737464208832, 51.06210954938143],
      [13.868060371953291, 51.06489077329521],
      [13.868071138992512, 51.084263007720594],
      [13.79682208461508, 51.08445792111634],
      [13.797139589281636, 51.15189329808307],
    ],
  },
}

// Actions
export const UPDATE_VIEWPORT = 'UPDATE_VIEWPORT'

// Reducer
const reducer = handleAction(
  UPDATE_VIEWPORT,
  (state, { payload }) => {
    const { viewport, transition } = payload
    return {
      ...state,
      transition,
      viewport: {
        ...state.viewport,
        ...viewport,
      },
    }
  },
  initialState
)
export default reducer

// Action creator
export const updateViewport = createAction(UPDATE_VIEWPORT)
